import { ReactNode, useEffect } from 'react';

import { clsx } from 'clsx';

import styles from './SignupLayout.module.css';
import { useCurrentStep } from '../../hooks/useCurrentStep';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import LogoHeading from '../LogoHeading/LogoHeading';
import MyAccount from '../MyAccount/MyAccount';
import PoweredByIwoca from '../PoweredByIwoca/PoweredByIwoca';
import Help from '../SidePanel/Help/Help';
import SidePanel from '../SidePanel/SidePanel';
import TrustPilot from '../TrustPilot/TrustPilot';

type TProps = {
  children: ReactNode;
};

const SignupLayout = ({ children }: TProps) => {
  const { isMobile } = useWindowDimensions();
  const currentStep = useCurrentStep();

  const showSidePanel = !(
    isMobile &&
    currentStep !== 'new' &&
    currentStep !== 'neu'
  );

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentStep]);

  return (
    <div className={styles.container}>
      {isMobile && <LogoHeading />}
      {showSidePanel && <SidePanel />}
      <div className={clsx(styles.signupContainer)}>
        <>
          {!isMobile && (
            <>
              <MyAccount isDesktop />
              <LogoHeading />
            </>
          )}
          <div className={styles.signupStepContainer}>{children}</div>
        </>
      </div>
      {isMobile && (
        <>
          <div className={styles.myAccountContainer}>
            <MyAccount />
          </div>
          <hr className={styles.footerBreak} />
          <div className={styles.footer}>
            <Help expanded />
            <div>
              <PoweredByIwoca />
              <TrustPilot />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SignupLayout;
